class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);

// Mega‐menu: hover stays open, closes shortly after leaving both summary & panel
document.querySelectorAll('header-menu details.mega-menu').forEach(menu => {
  let closeTimer;

  const summary = menu.querySelector('summary');
  const content = menu.querySelector('.mega-menu__content');

  // Open immediately, and cancel any pending close
  function openMenu() {
    clearTimeout(closeTimer);
    menu.open = true;
  }

  // Schedule a close 500ms later
  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      menu.open = false;
    }, 500);
  }

  // Bind events
  summary.addEventListener('mouseenter', openMenu);
  content.addEventListener('mouseenter', openMenu);

  summary.addEventListener('mouseleave', scheduleClose);
  content.addEventListener('mouseleave', scheduleClose);

  // Keyboard fallback: close when focus leaves entirely
  menu.addEventListener('focusout', e => {
    if (!menu.contains(e.relatedTarget)) {
      menu.open = false;
    }
  });
});
